module.exports = __webpack_public_path__ + "static/media/icon_themeAuto.27c57819.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_themeAuto.svg
// module id = 869
// module chunks = 7